const openInBrowser = async (url: string) => {
  window.open(url, "_blank");
};

export { openInBrowser };
